import { render } from "./shipping.vue?vue&type=template&id=062dcdae&scoped=true"
import script from "./shipping.vue?vue&type=script&lang=js"
export * from "./shipping.vue?vue&type=script&lang=js"

import "./shipping.vue?vue&type=style&index=0&id=062dcdae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-062dcdae"]])

export default __exports__